/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_LabelInputs */

const en_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept current correction`)
};

const fr_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter la correction actuelle`)
};

const de_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelle Korrektur akzeptieren`)
};

const it_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta la correzione corrente`)
};

const ru_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять текущую поправку`)
};

const es_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar la corrección actual`)
};

const zh_cn2_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受当前修正`)
};

const ja_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の修正を受け入れる`)
};

const hi_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान सुधार को स्वीकार करें`)
};

const pt_pt2_spellcheck_accept_label = /** @type {(inputs: Spellcheck_Accept_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar correção atual`)
};

/**
* | output |
* | --- |
* | "Accept current correction" |
*
* @param {Spellcheck_Accept_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_label = /** @type {((inputs?: Spellcheck_Accept_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_accept_label(inputs)
	if (locale === "de") return de_spellcheck_accept_label(inputs)
	if (locale === "it") return it_spellcheck_accept_label(inputs)
	if (locale === "ru") return ru_spellcheck_accept_label(inputs)
	if (locale === "es") return es_spellcheck_accept_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_accept_label(inputs)
	if (locale === "ja") return ja_spellcheck_accept_label(inputs)
	if (locale === "hi") return hi_spellcheck_accept_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_accept_label(inputs)
	return en_spellcheck_accept_label(inputs)
});